module.exports = __webpack_public_path__ + "static/media/cinema.c320d72e.svg";